import React from "react";
import firebase from "firebase";
import axios from "axios";

//Queries firebase for student data in pronunciation and flash cards
export function CreateRecordingAssignmentOptions(assignments, classLevel, page) {
    return new Promise((resolve) => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                let email = user.email;

                //Request student data with class level and page name
                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/' + page + '.json');
                studentFile.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        let studentData = res.data;
                        let assignmentNames = [];
                        let studentIndex = 0;
                        let found = false;

                        //search the data for the logged in user's email
                        for (let n = 0; n < studentData.length; n++) {
                            if (email === studentData[n].email) {
                                //Finds the index
                                studentIndex = n;
                                found = true;
                                break;
                            }
                        }

                        if (found) {
                            let assignmentNums = [];

                            //Then check the student's data what assignment numbers are stored
                            for (let n = 0; n < studentData[studentIndex].assignmentNum.length; n++) {
                                assignmentNums.push(studentData[studentIndex].assignmentNum[n])
                            }
                            for (let i = 0; i < assignments.length; i++) {

                                //If assignment number is found, add mic emoji
                                if (assignmentNums[i] === i) {
                                    assignmentNames.push({
                                        key: i,
                                        value: i,
                                        text: "Assignment " + (i + 1) + " 🎙️"
                                    })
                                } else {
                                    assignmentNames.push({
                                        key: i,
                                        value: i,
                                        text: "Assignment " + (i + 1)
                                    })
                                }
                            }
                            resolve(assignmentNames)
                        } else {
                            for (let i = 0; i < assignments.length; i++) {
                                assignmentNames.push({
                                    key: i,
                                    value: i,
                                    text: "Assignment " + (i + 1)
                                })
                            }
                            resolve(assignmentNames)
                        }


                    });


            } else {
                let assignmentNames = [];
                for (let i = 0; i < assignments.length; i++) {
                    assignmentNames.push({
                        key: i,
                        value: i,
                        text: "Assignment " + (i + 1)
                    })
                }
                resolve(assignmentNames)
            }
        });

    });
}
